import { GET } from '../dataSaver';
import { withQueryParams } from './portalTilesApi';
import { PARTNERS_URL } from './partnersApi';
import { normalizeProspect } from './prospectsApi';

/** Normalize HubSpot / CRM organization list responses. */
export const normalizeOrganizationsList = (data) => {
  if (Array.isArray(data)) return data.filter(Boolean);
  if (Array.isArray(data?.organizations)) return data.organizations.filter(Boolean);
  if (Array.isArray(data?.companies)) return data.companies.filter(Boolean);
  if (Array.isArray(data?.content)) return data.content.filter(Boolean);
  if (Array.isArray(data?.data)) return data.data.filter(Boolean);
  if (Array.isArray(data?.results)) return data.results.filter(Boolean);
  if (data && typeof data === 'object' && (data.organizationId || data.id)) {
    return [data];
  }
  return [];
};

export const normalizeOrganization = (organization) => {
  if (organization == null || organization === '') return null;
  if (typeof organization !== 'object') return null;
  const organizationId = String(
    organization.organizationId || organization.id || organization.companyId || ''
  ).trim();
  const organizationName = String(
    organization.organizationName ||
      organization.name ||
      organization.companyName ||
      ''
  ).trim();
  if (!organizationId && !organizationName) return null;
  return {
    organizationId,
    organizationName,
    domain: String(organization.domain || '').trim(),
    crmProvider: String(organization.crmProvider || '').trim(),
    logoUrl: String(
      organization.logoUrl || organization.organizationLogo || ''
    ).trim(),
  };
};

export const getOrganizationLabel = (organization) => {
  const normalized = normalizeOrganization(organization);
  if (!normalized) return '';
  if (normalized.domain) {
    return `${normalized.organizationName} (${normalized.domain})`;
  }
  return normalized.organizationName || normalized.organizationId;
};

/** Demo Studio create/update organization shape. */
export const toDemoShareOrganizationPayload = (organization) => {
  const normalized = normalizeOrganization(organization);
  if (!normalized?.organizationId) return null;
  const payload = {
    organizationId: normalized.organizationId,
    organizationName: normalized.organizationName || '',
  };
  if (normalized.domain) {
    payload.domain = normalized.domain;
  }
  return payload;
};

export const fetchPartnerOrganizations = async (
  partnerId,
  { search, limit = 20 } = {}
) => {
  const id = String(partnerId || '').trim();
  if (!id) return [];
  const { data } = await GET(
    withQueryParams(
      `${PARTNERS_URL}/${encodeURIComponent(id)}/organizations`,
      {
        search: String(search || '').trim() || undefined,
        limit,
      }
    )
  );
  return normalizeOrganizationsList(data)
    .map(normalizeOrganization)
    .filter(Boolean);
};

/** Normalize contacts list from organization contacts API. */
export const normalizeOrganizationContactsList = (data) => {
  if (Array.isArray(data)) return data.filter(Boolean);
  if (Array.isArray(data?.contacts)) return data.contacts.filter(Boolean);
  if (Array.isArray(data?.prospects)) return data.prospects.filter(Boolean);
  if (Array.isArray(data?.content)) return data.content.filter(Boolean);
  if (Array.isArray(data?.data)) return data.data.filter(Boolean);
  return [];
};

export const fetchOrganizationContacts = async (
  partnerId,
  organizationId,
  { search, limit = 20 } = {}
) => {
  const partner = String(partnerId || '').trim();
  const organization = String(organizationId || '').trim();
  if (!partner || !organization) return [];
  const { data } = await GET(
    withQueryParams(
      `${PARTNERS_URL}/${encodeURIComponent(partner)}/organizations/${encodeURIComponent(organization)}/contacts`,
      {
        search: String(search || '').trim() || undefined,
        limit,
      }
    )
  );
  return normalizeOrganizationContactsList(data)
    .map(normalizeProspect)
    .filter(Boolean);
};
